(function (){
    'use strict';

    angular
        .module('services')
        .service('PayrollService', PayrollService);

    PayrollService.$inject = ['$http', 'API_BASE'];

    function PayrollService ($http, API_BASE) {
        var service = this;

        service.getPayroll              = getPayroll;
        service.savePayroll             = savePayroll;
        service.editPayroll             = editPayroll;
        service.sendEmailPayrrolReport  = sendEmailPayrrolReport;
        service.savePayroll             = savePayroll;
        service.deletePayroll           = deletePayroll;
        service.edit                    = edit;
        service.update                  = update;
        service.deletePayrollItem       = deletePayrollItem;
       // service.finishPayroll = finishPayroll;
        
        function getPayroll(query) {
            return $http.get(API_BASE + '/payroll/list', {params:query});
        }

        function savePayroll(query) {
            return $http.post(API_BASE + '/payroll/save', query);
        }

        function editPayroll(query) {
            return $http.get(API_BASE + '/payroll/edit', {params:query});
        }

        function sendEmailPayrrolReport(query) {
            return $http.get(API_BASE + '/payroll/send-email-payroll-report', {params: query});
        }
        
        function deletePayroll(query) {
            return $http.get(API_BASE + '/payroll/delete', {params: query});
        }

        function deletePayrollItem(id) {
            return $http.delete(API_BASE + '/payroll/item/delete/' + id);
        }


        function edit(query) {
            return $http.get(API_BASE + '/payroll/edit', {params: query});
        }
        
        function update(query) {
            return $http.put(API_BASE + '/payroll/update-payroll', query);
        }
        // function finishPayroll(query) {
        //     return $http.get(API_BASE + '/payroll/finish', {params: query});
        // }

        
    }
})();